import { mutator } from "satcheljs";
import { type SET_MODULE_CONTEXT_MAILBOXINFOActionMessage, default as setModuleContextMailboxInfo, } from "../actions/setModuleContextMailboxInfo";
import getModuleContextMailboxInfoStore from "../store/moduleContextMailboxInfoStore";

/* eslint-disable-next-line owa-custom-rules/prefer-mutator-action -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!
 *	> Please use a mutatorAction if action is defined in the same package */
const defaultExport: (actionMessage: SET_MODULE_CONTEXT_MAILBOXINFOActionMessage) => void = mutator(setModuleContextMailboxInfo, actionMessage => {
    getModuleContextMailboxInfoStore().moduleContextMailboxInfos.set(actionMessage.module, actionMessage.mailboxInfo);
});
export default defaultExport;
